import { Navigate } from 'react-router-dom';
import { Counter } from './components/Counter';
import { FetchData } from './components/FetchData';
import Connect from './components/Connect/Connect';
import { Home } from './components/Home/Home';
import { BackgroundPage, NotePage, NotesPage, NotFoundPage, ProjectPage } from './components/Portfolio/PortfolioPages';
import CreditsPage from './components/Portfolio/CreditsPage';

const AppRoutes = [
  { index: true, element: <Home /> },
  { path: '/connect', element: <Connect /> },
  { path: '/connect/aicard', element: <Connect /> },
  { path: '/connect/:slug', element: <Navigate to="/connect" replace /> },
  { path: '/projects/:slug', element: <ProjectPage /> },
  { path: '/notes', element: <NotesPage /> },
  { path: '/notes/:slug', element: <NotePage /> },
  { path: '/background', element: <BackgroundPage /> },
  { path: '/credits', element: <CreditsPage /> },
  { path: '/counter', element: <Counter /> },
  { path: '/fetch-data', element: <FetchData /> },
  { path: '*', element: <NotFoundPage /> }
];

export default AppRoutes;
